import axios from "axios";
import ENV from "constants/env";

const axiosInstance = axios.create({
    baseURL: ENV.BASE_URL,
    headers: {
        "X-API-key": ENV.API_KEY
    }
});

export default axiosInstance;